import Config from "../Config";
import token from "../AuthToken";


const setCaptain = function (e) {
    const playerId = e.currentTarget.dataset.playerId;
    fetch(Config.setCaptainUrl.replace("/0/", "/" + playerId + "/"), {
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        },
        method: "PUT",
        data: JSON.stringify({})
    })
    .then((e) => e.json())
    .catch((e) => {
        console.log(e)
        window.location.reload();
    });
}

const getTrophies = function(setTrophies) {
    fetch(Config.getTrophiesUrl,{
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        },
        method: "GET",
    })
    .then((e) => e.json())
    .then((e) => {
        setTrophies(e.results);
    })
    .catch((e) => {
        console.error("Error getting trophies", e);
    });
}

const acknowledgeTrophy = function(trophyId, alreadyNotifiedRef) {
    fetch(Config.setTrophiesUrl.replace("/0/", "/"+trophyId+"/"),{
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        },
        method: "PUT",
        data: JSON.stringify({id: trophyId})
    })
    .then((e) => e.json())
    .then((e) => alreadyNotifiedRef.current.add(trophyId))
    .catch((e) => {
        console.log(e)
        //window.location.reload();
        console.error("Error setting trophy as acknowledge", e);
    });
}

const getTournaments = function(setTournaments) {
    fetch(Config.getTournamentsUrl,{
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        },
        method: "GET",
    })
    .then((e) => e.json())
    .then((e) => {
        setTournaments(e.results);
    })
    .catch((e) => {
        console.error("Error getting tournaments", e);
    });
}

export {setCaptain, getTrophies, acknowledgeTrophy, getTournaments};